const DAYS = ["E Hënë", "E Martë", "E Mërkurë", "E Enjte", "E Premte", "E Shtunë", "E Diel"];

export default function WaAutoReplies({ cfg, set }) {
    const hours = cfg.hours || {};
    const setDay = (i, patch) => set("hours", { ...hours, [i]: { ...(hours[i] || {}), ...patch } });

    return (
        <div className="space-y-4" data-testid="wa-auto-replies">
            <div className="font-display font-black uppercase pt-4">Përgjigje automatike</div>
            <label className="flex items-center gap-2 text-sm">
                <input type="checkbox" checked={!!cfg.auto_location_enabled} onChange={(e) => set("auto_location_enabled", e.target.checked)} data-testid="wa-auto-location-enabled" />
                Dërgo lokacionin 📍 kur klienti pyet për adresën
            </label>
            <label className="block">
                <span className="label-kicker mb-1 block">Fjalët që e aktivizojnë (ndani me presje)</span>
                <textarea
                    rows="2"
                    value={(cfg.auto_location_keywords || []).join(", ")}
                    onChange={(e) => set("auto_location_keywords", e.target.value.split(",").map((k) => k.trimStart()))}
                    className="input-field text-xs"
                    data-testid="wa-auto-location-keywords"
                />
                <span className="block text-[11px] text-slate-500 mt-1">Dërgohet maksimumi 1 herë në 6 orë për çdo klient.</span>
            </label>

            <label className="flex items-center gap-2 text-sm pt-2">
                <input type="checkbox" checked={!!cfg.hours_enabled} onChange={(e) => set("hours_enabled", e.target.checked)} data-testid="wa-hours-enabled" />
                Përgjigju automatikisht jashtë orarit të punës
            </label>
            <div className="rounded-lg border border-slate-200 divide-y divide-slate-100" data-testid="wa-hours-table">
                {DAYS.map((d, i) => {
                    const h = hours[i] || {};
                    return (
                        <div key={d} className="flex items-center gap-3 px-3 py-1.5 text-sm" data-testid={`wa-hours-day-${i}`}>
                            <span className="w-24 shrink-0 font-semibold">{d}</span>
                            <input type="time" value={h.open || ""} disabled={h.closed} onChange={(e) => setDay(i, { open: e.target.value })} className="input-field !w-36 !py-1 !px-2 font-mono text-xs disabled:opacity-40" />
                            <span className="text-slate-400">–</span>
                            <input type="time" value={h.close || ""} disabled={h.closed} onChange={(e) => setDay(i, { close: e.target.value })} className="input-field !w-36 !py-1 !px-2 font-mono text-xs disabled:opacity-40" />
                            <label className="ml-auto flex items-center gap-1.5 text-xs text-slate-500">
                                <input type="checkbox" checked={!!h.closed} onChange={(e) => setDay(i, { closed: e.target.checked })} /> Mbyllur
                            </label>
                        </div>
                    );
                })}
            </div>
            <label className="block">
                <span className="label-kicker mb-1 block">Mesazhi jashtë orarit</span>
                <textarea rows="4" value={cfg.hours_message || ""} onChange={(e) => set("hours_message", e.target.value)} className="input-field text-sm" data-testid="wa-hours-message" />
                <span className="block text-[11px] text-slate-500 mt-1">{"{orari}"} zëvendësohet me orarin e mësipërm. Dërgohet maksimumi 1 herë në 12 orë për çdo klient.</span>
            </label>
        </div>
    );
}
